/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import RenderItems from 'components/base-elements/review-report/RenderItems';
import { CustomPagination } from 'components/cost-planning/table-pagination';
import ReportAccess from 'components/report-access';
import SortableHeader from 'components/table-sorting';
import { PAGINATION_VALUES, RE_RUN_REPORT_CONSTANTS } from 'constants/common.constants';
import { ENV_VARS } from 'constants/environment.constants';
import { REPORT_ACCESS_CONSTANTS } from 'constants/report-access';
import { useSseStream } from 'hooks';
import {
  KF1Table,
  ODSAvatar,
  ODSButton,
  ODSModal,
  odsToastNotification,
  ODSToastNotificationContainer,
} from 'kfone-component-library';
import { ButtonTheme, ToastNotificationVariant } from 'kfone-component-library/enums';
import {
  CloseIcon,
  DocumentReportIcon,
  MoreVerticalIcon,
  PencilIcon,
  RefreshIcon,
  TrashIcon,
  UserAddIcon,
} from 'kfone-component-library/svgIcons';
import { kf1GetUserNameInitial } from 'kfone-component-library/utilities';
import { TABLE_ACTION_MENU_NAME } from 'model/constants';
import { IReportListData, IReportsListResponse } from 'model/interfaces/reports-list';
import { useEffect, useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getPayFactors } from 'services/pay-factors';
import { deleteReport, getReportsListList } from 'services/reports-list';
import {
  useCreateReportStore,
  useFileStore,
  useReportDeailStore,
  useReportStatusStore,
} from 'store';
import useCountryStore from 'store/CountryStore';
import useNewReportStore from 'store/NewReport';
import { getUpdatedSortState, sessionCheck, sortData, SortState } from 'utilities';
import { getPayFactorLabel } from 'utilities/pay-factor-translation';
import './reports-list.css';
import {
  NEW_REPORT_INTERNAL_STATUS_ROUTES,
  ReportStatusColorCodes,
  ReportStatusId,
  STATUS_DISPLAY_GROUP,
} from './reports-lists.constants';

export const ReportsList = (props: any) => {
  const { updateReportInfo, resetReportDetailsData } = useReportDeailStore();
  const [reports, setReports] = useState<SortState<keyof IReportsListResponse>>({
    column: null,
    direction: null,
  });
  const navigate: any = useNavigate();
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedPageSize, setSelectedPageSize] = useState<number>(10);
  const [updatedItems, setUpdatedItems] = useState<IReportsListResponse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { setActiveStepId, setActiveSubStepId } = useReportStatusStore();
  const {
    updateActivationStepsStore,
    setReportId,
    resetReportStore: resetNewReportStore,
    updateActivatedSubStepsStore,
  } = useNewReportStore();
  const { storePrevReportData, setIsReportCreated, setIsReportRerun, resetStore } =
    useCreateReportStore();
  const { addReportName, updateSelectedCountryCode } = useCountryStore();
  const { updateFileHasErrorsState, updateCountryCode, updateFileReportId } = useFileStore();
  const [payFactorsMap, setPayFactorsMap] = useState<Record<number, string[]>>({});
  const [loadingPayFactors, setLoadingPayFactors] = useState<Record<number, boolean>>({});
  const [deleteTarget, setDeleteTarget] = useState<IReportsListResponse | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [accessReportItem, setAccessReportItem] = useState<IReportsListResponse | null>(null);
  const [selectedActionItemName, setSelectedActionItemName] = useState<string | null>(null);
  const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);

  useEffect(() => {
    void getData().finally(() => setIsInitialLoadDone(true));
    resetReportDetailsData();
    resetStore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToReportDetails = (reportData: IReportsListResponse) => {
    const childReportList = (reportData?.childReportList || []).filter(
      (childReport: IReportListData) =>
        childReport?.reportStatus === ReportStatusId.AnalysisComplete ||
        childReport?.reportStatus === ReportStatusId.CostPlanningInprogress ||
        childReport?.reportStatus === ReportStatusId.CostPlanningComplete,
    );
    const updatedReportData: IReportsListResponse = {
      ...reportData,
      ...(childReportList.length > 0 ? childReportList[0] : {}),
    };
    setReportId(updatedReportData?.reportId);
    updateReportInfo(updatedReportData);
    navigate('/payequity/report-details');
  };

  const applyReportsListData = (data: IReportsListResponse[]) => {
    const recentOrAllReports = props.isRecentReport ? data.slice(0, 10) : data;
    const newData: IReportsListResponse[] = recentOrAllReports?.map((ele: any, index: number) => {
      return {
        ...ele,
        name: getReportNameCell(ele),
        versionlabel: getVersionLabelCell(ele),
        action: getActionCell(ele, index),
        status: getStatusCell(ele),
        datecreated: getDateCell(ele, 'dateCreated'),
        lastupdate: getDateCell(ele, 'lastUpdate'),
        uploaddate: getDateCell(ele, 'uploadDate'),
      };
    });
    setUpdatedItems(newData);
    if (typeof props?.updateCount === 'function') props?.updateCount(newData.length);
  };

  const getData = async () => {
    // Check if session is timed out before making API call
    if (sessionCheck()) {
      console.log('Session timed out - skipping API call');
      setIsLoading(false);
      return;
    }

    // setTriggerStatus(false);
    const response: any = await getReportsListList();
    const { responseCode, data } = response;
    if (responseCode === 200 && data?.length > 0) {
      applyReportsListData(data);
    }
    setIsLoading(false);
  };

  const handleReportsSseEvent = (eventData: unknown) => {
    const response = eventData as {
      responseCode?: number;
      data?: IReportsListResponse[];
      type?: string;
    };
    if (response?.type === 'heartbeat') {
      return;
    }
    if (response?.responseCode === 200 || response?.responseCode === 204) {
      applyReportsListData(response.data ?? []);
      setIsLoading(false);
    }
  };

  const reportsSseUrl = useMemo(() => `${ENV_VARS.API_URL}v2/events/reports`, []);
  useSseStream(reportsSseUrl, handleReportsSseEvent, isInitialLoadDone && !sessionCheck());
  const deleteRecord = async (reportId: number, reportName?: string) => {
    const path = window.location.pathname;
    const toastStyle =
      path === '/payequity'
        ? { left: '15%' }
        : path === '/payequity/saved-reports'
          ? { left: '15%', bottom: '45px' }
          : { left: '15%' };

    try {
      setUpdatedItems((prev) => prev.filter((r) => Number(r.reportId) !== Number(reportId)));
      const response: any = await deleteReport(reportId);
      const { responseCode } = response;
      if (responseCode === 200) {
        void getData();

        odsToastNotification({
          title: (
            <span className='font-bold'>
              {t('pe.reportDeletedTitle', { defaultValue: 'Report deleted successfully.' })}
            </span>
          ),
          description: (
            <span>
              {t('pe.reportDeletedToastPrefix', {
                defaultValue: 'Your report',
              })}{' '}
              <span className='font-semibold'>{reportName ?? ''}</span>{' '}
              {t('pe.reportDeletedToastSuffix', {
                defaultValue: 'has been deleted successfully.',
              })}
            </span>
          ),
          variant: ToastNotificationVariant.Success,
          options: {
            autoClose: 3000,
            style: toastStyle,
          },
        });
      } else {
        odsToastNotification({
          title: t('pe.reportDeleteFailedTitle', { defaultValue: 'Delete failed' }),
          description: t('pe.reportDeleteFailed', {
            defaultValue: 'Unable to delete the report. Please try again.',
          }),
          variant: ToastNotificationVariant.Error,
          options: {
            autoClose: 5000,
            style: toastStyle,
          },
        });
      }
    } catch (err) {
      void getData();
      odsToastNotification({
        title: t('pe.deleteErrorTitle', { defaultValue: 'Error' }),
        description: t('pe.deleteErrorMsg', { defaultValue: 'An unexpected error occurred.' }),
        variant: ToastNotificationVariant.Error,
        options: { autoClose: 5000, style: toastStyle },
      });
    }
  };

  const handleCancelDelete = () => {
    setDeleteTarget(null);
    setIsDeleting(false);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget?.reportId) return;
    setIsDeleting(true);
    await deleteRecord(Number(deleteTarget.reportId), String(deleteTarget?.reportName ?? ''));
    setIsDeleting(false);
    setDeleteTarget(null);
  };

  const editReport = (row: any) => {
    if (row?.reportInternalStatus === NEW_REPORT_INTERNAL_STATUS_ROUTES.ERROR) {
      // eslint-disable-next-line no-undef
      return;
    }
    resetNewReportStore(row?.reportId);
    addReportName(String(row?.parentName ?? row?.reportName));
    updateSelectedCountryCode(String(row?.countryCode));
    setReportId(row?.reportId);
    setIsReportCreated(true);
    storePrevReportData(row);
    updateFileHasErrorsState(false);
    updateCountryCode(row?.countryCode);
    updateFileReportId(row?.reportId);
    switch (row?.reportInternalStatus) {
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.DATA_LOAD_FAILED:
        updateFileHasErrorsState(true);
        setActiveStepId(1);
        updateActivationStepsStore(1);
        updateActivationStepsStore(1);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.DATA_LOAD_PENDING:
        setActiveStepId(1);
        updateActivationStepsStore(1);
        updateActivationStepsStore(1);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.COMPATIBILITY_CHECK_IN_PROGRESS:
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.POPULATION_SCOPE_IN_PROGRESS:
        setActiveStepId(1.5);
        updateActivationStepsStore(1.5);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.DATA_LOAD_DONE:
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.FILE_UPLOAD_DONE:
        setActiveStepId(2);
        setActiveSubStepId(0);
        updateActivationStepsStore(2);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.COMPENSATION_DONE:
        setActiveStepId(2);
        setActiveSubStepId(1);
        updateActivatedSubStepsStore(1);
        updateActivationStepsStore(2);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.DEMOGRAPHICS_DONE:
        setActiveStepId(2);
        setActiveSubStepId(3);
        updateActivatedSubStepsStore(3);
        updateActivationStepsStore(2);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.GROUPS:
        setActiveStepId(2);
        setActiveSubStepId(2);
        updateActivatedSubStepsStore(2);
        updateActivationStepsStore(2);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.PAY_FACTORS:
        setActiveStepId(3);
        setActiveSubStepId(2);
        updateActivatedSubStepsStore(2);
        updateActivationStepsStore(3);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.DATA_VALIDATION:
        setActiveStepId(4);
        setActiveSubStepId(2);
        updateActivatedSubStepsStore(2);
        updateActivationStepsStore(4);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.REVIEW_AND_RUN:
        setActiveStepId(5);
        setActiveSubStepId(2);
        updateActivatedSubStepsStore(2);
        updateActivationStepsStore(5);
        break;
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.ANALYSIS_COMPLETE:
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.COST_PLANNING_COMPLETE:
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.COST_PLANNING_INPROGRESS:
      case NEW_REPORT_INTERNAL_STATUS_ROUTES.COST_PLANNING_INCOMPLETE:
        setActiveStepId(5);
        setActiveSubStepId(2);
        updateActivatedSubStepsStore(2);
        updateActivationStepsStore(5);
        break;
    }
    navigate('/payequity/generate-report');
  };

  const fetchPayFactors = async (reportId: number) => {
    if (payFactorsMap[reportId] || loadingPayFactors[reportId]) return;
    setLoadingPayFactors((prev) => ({ ...prev, [reportId]: true }));
    try {
      const res = await getPayFactors(reportId);
      const factors = Array.isArray(res?.data)
        ? res.data
            .filter((item: any) => item?.activeFlag)
            .map((item: any) => getPayFactorLabel(item?.payFactorLabel, t))
            .filter(Boolean)
        : [];
      setPayFactorsMap((prev) => ({ ...prev, [reportId]: factors }));
    } catch (e) {
      setPayFactorsMap((prev) => ({ ...prev, [reportId]: [] }));
    } finally {
      setLoadingPayFactors((prev) => {
        const copy = { ...prev };
        delete copy[reportId];
        return copy;
      });
    }
  };

  const checkReportNameClickable = (report: IReportsListResponse) => {
    const checkRunHistoryStatus = (report?.childReportList || []).some(
      (childReport: IReportListData) =>
        childReport?.reportStatus === ReportStatusId.AnalysisComplete ||
        childReport?.reportStatus === ReportStatusId.CostPlanningInprogress ||
        childReport?.reportStatus === ReportStatusId.CostPlanningComplete,
    );
    return (
      report?.reportStatus === ReportStatusId.AnalysisComplete ||
      report?.reportStatus === ReportStatusId.CostPlanningInprogress ||
      report?.reportStatus === ReportStatusId.CostPlanningComplete ||
      checkRunHistoryStatus
    );
  };

  const getReportNameCell = (row: any) => {
    const factors = payFactorsMap[row.reportId];
    const isLoading = !!loadingPayFactors[row.reportId];
    const isReportNameClickable = checkReportNameClickable(row);
    return (
      <div
        className={`action-cell max-w-[279px] whitespace-pre-wrap break-words ${isReportNameClickable ? 'report-name' : ''}`}
        onClick={() => (isReportNameClickable ? goToReportDetails(row) : null)}
      >
        <div
          className='tooltip-wrapper'
          onMouseEnter={() => fetchPayFactors(row.reportId)}
          onFocus={() => fetchPayFactors(row.reportId)}
        >
          {row?.parentName ?? row?.reportName ?? ''}
          <div className='tooltip-card' aria-label='Pay factors'>
            <div className='tooltip-header pb-2 font-semibold'>
              {factors && factors.length > 1
                ? t('pe.landingPage.payFactors')
                : t('pe.landingPage.payFactor')}
            </div>
            <div className='tooltip-chip-grid'>
              {factors ? (
                factors.length > 0 ? (
                  <RenderItems items={factors} />
                ) : (
                  <span className='text-s text-ods-color-brand-neutral-600'>
                    {t('pe.landingPage.noPayFactor')}
                  </span>
                )
              ) : isLoading ? (
                <span className='text-s text-gray-500'>{t('pe.loadingPleaseWait')}</span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleActionMenuClick = (index: number, event: any) => {
    setSelectedActionItemName(TABLE_ACTION_MENU_NAME + index);
    event.stopPropagation();
  };

  const handleRerunClick = (row: IReportsListResponse) => {
    if (row?.reportInternalStatus === NEW_REPORT_INTERNAL_STATUS_ROUTES.ERROR) {
      return;
    }
    setIsReportCreated(true);
    setIsReportRerun(RE_RUN_REPORT_CONSTANTS.COMPATIBILITY_REVIEW);
    updateFileHasErrorsState(false);
    resetNewReportStore(row?.reportId);
    addReportName(String(row?.parentName ?? row?.reportName));
    updateSelectedCountryCode(String(row?.countryCode));
    setReportId(row?.reportId);
    storePrevReportData(row);
    updateCountryCode(row?.countryCode);
    updateFileReportId(row?.reportId);
    setActiveStepId(1);
    updateActivationStepsStore(1);
    navigate('/payequity/generate-report');
  };

  const getVersionLabelCell = (row: IReportsListResponse) => {
    return (
      <div className='report-current-version'>
        {row?.versionLabel ?? t('pe.run', { defaultValue: 'Run' }) + ' 1'}
      </div>
    );
  };

  const getActionCell = (row: any, index: number) => {
    const hasView = (row?.permission ?? []).includes(REPORT_ACCESS_CONSTANTS.VIEW_PERMISSION_CODE);
    const hasEdit = (row?.permission ?? []).includes(REPORT_ACCESS_CONSTANTS.EDIT_PERMISSION_CODE);
    const hasDelete = (row?.permission ?? []).includes(
      REPORT_ACCESS_CONSTANTS.DELETE_PERMISSION_CODE,
    );
    return (
      <div className='action-cell flex items-center justify-end gap-4'>
        {hasEdit &&
          row?.reportinternalstatus !== NEW_REPORT_INTERNAL_STATUS_ROUTES.ERROR &&
          (row?.reportStatus === ReportStatusId.ConfigurationInProgress ||
            row?.reportStatus === ReportStatusId.CostPlanningInprogress ||
            row?.reportStatus === ReportStatusId.CostPlanningInComplete) &&
          (row?.reportStatus !== ReportStatusId.AnalysisInProgress ||
            row?.reportStatus !== ReportStatusId.CostPlanningInprogress) && (
            <PencilIcon
              className='ods-color-button-background-primary-default flex-none cursor-pointer stroke-2'
              onClick={(e: any) => {
                editReport(row);
              }}
            />
          )}
        {hasEdit && hasDelete && (
          <div id={TABLE_ACTION_MENU_NAME + index} className='action-menu-container'>
            <MoreVerticalIcon
              id={TABLE_ACTION_MENU_NAME + index}
              className='cursor-pointer stroke-2'
              onClick={(e: any) => {
                handleActionMenuClick(index, e);
              }}
            />
            {selectedActionItemName === TABLE_ACTION_MENU_NAME + index && (
              <div className='action-menu-content'>
                {/* Clone:  (needs DuplicateIcon import). */}
                {/* {(hasView || hasEdit) &&
                    (row?.reportStatus === ReportStatusId.AnalysisComplete ||
                      row?.reportStatus === ReportStatusId.CostPlanningComplete) && (
                      <div className='action-menu-option'>
                        <DuplicateIcon className='flex-none cursor-pointer stroke-2' />
                        <span className='option-text'>{t('pe.clone')}</span>
                      </div>
                    )} */}
                {hasEdit &&
                  (row?.reportStatus === ReportStatusId.AnalysisComplete ||
                    row?.reportStatus === ReportStatusId.CostPlanningComplete ||
                    row?.reportStatus === ReportStatusId.CostPlanningInComplete ||
                    row?.reportStatus === ReportStatusId.CostPlanningInprogress) && (
                    <div
                      id={`rerun_menu_option_${row?.reportId ?? ''}`}
                      className='action-menu-option'
                      onClick={(e: any) => {
                        e.stopPropagation();
                        handleRerunClick(row);
                      }}
                    >
                      <RefreshIcon className='flex-none cursor-pointer stroke-2' />
                      <span>{t('pe.rerun', { defaultValue: 'Rerun' })}</span>
                    </div>
                  )}
                {hasDelete && (
                  <div
                    className='action-menu-option'
                    onClick={() => {
                      setDeleteTarget(row);
                      setSelectedActionItemName(null);
                    }}
                  >
                    <TrashIcon className='flex-none cursor-pointer stroke-2 text-ods-color-utility-danger-500' />
                    <span>{t('pe.common.delete')}</span>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const getStatusCell = (row: any) => {
    return (
      <div
        className='report-status-cell [#243D42] flex w-fit rounded-ods-border-radius-components-border-radius-medium px-[8px] py-[6px]'
        style={{
          color: '#243D42',
          backgroundColor:
            row?.reportStatus && ReportStatusColorCodes[row?.reportStatus]
              ? ReportStatusColorCodes[row?.reportStatus]
              : '',
        }}
      >
        {row?.reportInternalStatus
          ? t(
              `pe.db.${STATUS_DISPLAY_GROUP[row.reportInternalStatus] ?? row.reportInternalStatus}`,
              { defaultValue: row?.reportStatus },
            )
          : row?.reportStatus}
      </div>
    );
  };

  const getDateCell = (row: any, field: string) => {
    if (!row[field]) return '';
    const date: Date = new Date(row[field] as string | number | Date);
    const formattedStartTime = date.toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
    });
    return <div className='report-date flex'>{formattedStartTime}</div>;
  };
  const handleSort = (column: keyof IReportsListResponse) => {
    setReports((prev) => getUpdatedSortState(prev, column));
  };

  const reportsTableHeaders: any[] = [
    {
      id: 'reportName',
      label: (
        <SortableHeader
          label={t('pe.name')}
          columnKey='reportName'
          currentSortColumn={reports.column}
          currentSortDirection={reports.direction}
          onSort={handleSort}
          testId='kf1-table-reportName-sort-button'
        />
      ),
      width: '25%',
    },
    {
      id: 'versionlabel',
      label: (
        <SortableHeader
          label={t('pe.currentVersion', { defaultValue: 'Current Run' })}
          columnKey='versionLabel'
          currentSortColumn={reports.column}
          currentSortDirection={reports.direction}
          onSort={handleSort}
          testId='kf1-table-currentVersion-sort-button'
        />
      ),
      width: '18%',
    },
    {
      id: 'datecreated',
      label: (
        <SortableHeader
          label={t('pe.dateCreated')}
          columnKey='dateCreated'
          currentSortColumn={reports.column}
          currentSortDirection={reports.direction}
          onSort={handleSort}
          testId='kf1-table-dateCreated-sort-button'
        />
      ),
      width: '16%',
    },
    {
      id: 'uploaddate',
      label: (
        <SortableHeader
          label={t('pe.uploadDate')}
          columnKey='uploadDate'
          currentSortColumn={reports.column}
          currentSortDirection={reports.direction}
          onSort={handleSort}
          testId='kf1-table-uploadDate-sort-button'
        />
      ),
      width: '16%',
    },
    {
      id: 'lastupdate',
      label: (
        <SortableHeader
          label={t('pe.lastUpdate')}
          columnKey='lastUpdate'
          currentSortColumn={reports.column}
          currentSortDirection={reports.direction}
          onSort={handleSort}
          testId='kf1-table-lastUpdate-sort-button'
        />
      ),
      width: '16%',
    },
    {
      id: 'reportStatus',
      label: (
        <SortableHeader
          label={t('pe.status')}
          columnKey='reportStatus'
          currentSortColumn={reports.column}
          currentSortDirection={reports.direction}
          onSort={handleSort}
          testId='kf1-table-reportStatus-sort-button'
        />
      ),
      width: '25%',
    },
    {
      id: 'access',
      label: (
        <SortableHeader
          label={t('pe.access')}
          columnKey='sharedWithList'
          currentSortColumn={reports.column}
          currentSortDirection={reports.direction}
          onSort={handleSort}
          testId='kf1-table-access-sort-button'
        />
      ),
      width: '15%',
    },
    {
      id: 'action',
      label: t('pe.rdr.actions'),
      width: '10%',
    },
  ];

  const getAccessCell = (row: IReportsListResponse) => {
    const creator = row?.createdBy?.trim();
    const items = [
      ...(creator ? [{ avatarText: kf1GetUserNameInitial(creator), tooltipText: creator }] : []),
      ...(row?.sharedWithList ?? [])
        .map((user) => [user.firstName, user.lastName].filter(Boolean).join(' ').trim())
        .filter(Boolean)
        .map((fullName) => ({
          avatarText: kf1GetUserNameInitial(fullName),
          tooltipText: fullName,
        })),
    ];
    const hasEdit = (row?.permission ?? []).includes(REPORT_ACCESS_CONSTANTS.EDIT_PERMISSION_CODE);

    return (
      <div className='flex items-center gap-1'>
        {items.length > 0 && <ODSAvatar id={`avatar-access-${row.reportId}`} items={items} />}
        {hasEdit &&
          (row?.reportStatus === ReportStatusId.AnalysisComplete ||
            row?.reportStatus === ReportStatusId.CostPlanningInprogress ||
            row?.reportStatus === ReportStatusId.CostPlanningComplete ||
            row?.reportStatus === ReportStatusId.CostPlanningInComplete) && (
            <UserAddIcon
              className='cursor-pointer stroke-2'
              onClick={() => {
                setAccessReportItem(row);
              }}
            />
          )}
      </div>
    );
  };

  const noReports = () => {
    return (
      <div className='no-replorts'>
        <div className='recent-reports-container' data-testid='recent-reports-container'>
          {/* <div className='text-ods-font-styles-heading-small'>
            {t('pe.landingPage.recentReports')}
          </div> */}
          <div className='recent-reports-content'>
            <div className='recent-reports-content-item'>
              <DocumentReportIcon className='document-report-icon' />
              <p>{t('pe.landingPage.recentReports.noReportsDesc')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const handlePageChange = (pageNumber: number, pageSize: number = selectedPageSize) => {
    setCurrentPage(pageNumber);
    setSelectedPageSize(pageSize);
  };
  const getTableData = () => {
    let sortedReports = sortData(updatedItems, reports);

    const startIndex = (currentPage - 1) * selectedPageSize;
    const endIndex = startIndex + selectedPageSize;

    const paginated = props.isRecentReport
      ? sortedReports.slice(0, 10)
      : sortedReports.slice(startIndex, endIndex);

    return paginated.map((report, index: number) => ({
      reportName: getReportNameCell(report),
      versionlabel: getVersionLabelCell(report),
      datecreated: getDateCell(report, 'dateCreated'),
      uploaddate: getDateCell(report, 'uploadDate'),
      lastupdate: getDateCell(report, 'lastUpdate'),
      reportStatus: getStatusCell(report),
      access: getAccessCell(report),
      action: getActionCell(report, index),
    }));
  };

  const handleReportAccessModelClose = (data?: IReportsListResponse) => {
    if (data) {
      setUpdatedItems((prevList) =>
        prevList.map((item) =>
          item.reportId === data.reportId ? { ...item, sharedWithList: data.sharedWithList } : item,
        ),
      );
    }
    setAccessReportItem(null);
  };

  const handleDocumentClick = (event: any) => {
    setSelectedActionItemName(null);
  };

  useEffect(() => {
    // Add the event listener when the component mounts
    document.addEventListener('click', (event) => {
      handleDocumentClick(event); // Call the handler to check if the click is outside the target element
    });
    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  return (
    <div className='report-list'>
      {!isLoading && updatedItems && updatedItems.length < 1 ? (
        <div>{noReports()}</div>
      ) : (
        <div className='reports-list-table-content'>
          <KF1Table
            id='reports-list'
            data={getTableData()}
            tableHeaders={reportsTableHeaders}
            loader={{ isTableLoading: isLoading }}
          />
          {!props.isRecentReport && !isLoading && (
            <CustomPagination
              id='pagination'
              totalItems={updatedItems?.length ?? 0}
              selectedPageSize={selectedPageSize}
              currentPage={currentPage}
              onChange={handlePageChange}
              pageSizeOptions={PAGINATION_VALUES.PAGE_SIZE_OPTIONS}
            />
          )}
        </div>
      )}

      {accessReportItem && (
        <ReportAccess
          isOpen={true}
          onClose={handleReportAccessModelClose}
          reportData={accessReportItem}
        />
      )}

      {deleteTarget && (
        <ODSModal
          id='delete-report-modal'
          isOpen={true}
          onClose={handleCancelDelete}
          bodyContent={
            <div className='delete-modal-content relative mb-2 min-w-[480px]'>
              <div className='flex items-center justify-between'>
                <h1 className='text-lg font-bold'>
                  {t('pe.deleteReportTitle', { defaultValue: 'Delete Report' })}
                </h1>
                <CloseIcon
                  className='text-ods-color-text-color-default cursor-pointer'
                  onClick={handleCancelDelete}
                />
              </div>

              <div className='mt-6 text-base text-gray-800'>
                <Trans
                  i18nKey='pe.deleteReportConfirm'
                  values={{ filename: deleteTarget.reportName || '' }}
                  components={[<span key='file-name' className='font-semibold' />]}
                />
              </div>

              <div className='mt-6 flex w-full items-center justify-between pl-1'>
                <ODSButton
                  id='cancel-delete-btn'
                  onClick={handleCancelDelete}
                  theme={ButtonTheme.Tertiary}
                >
                  {t('pe.cancel')}
                </ODSButton>

                <ODSButton
                  id='confirm-delete-btn'
                  onClick={handleConfirmDelete}
                  theme={ButtonTheme.Primary}
                >
                  {t('pe.common.delete', { defaultValue: 'Delete' })}
                </ODSButton>
              </div>
            </div>
          }
        />
      )}

      <ODSToastNotificationContainer />
    </div>
  );
};
